import React        from 'react'

const Container = props => {
    return (
        <div className="blogs-details-container">
            { props.children }
        </div>
    )
}

export default Container
